import { Component, OnInit, ViewChild } from '@angular/core';
import { GridComponent } from '../../../../../core/shared/grid/grid.component';
import { Router, ActivatedRoute } from '@angular/router';
import { CustomersRest } from '../../../customers.rest';
import { SystemVersionsSelectionComponent } from '../system-versions-selection/system-versions-selection.component';
import { Customer, CustomerSystemVersion } from '../../../customers.model';
import { Permissions, HasPermissions } from '../../../../../core/services/permissions/permissions.model';
import { PermissionsService } from '../../../../../core/services/permissions/permissions.service';

@Component({
  selector: 'app-customer-system-versions',
  templateUrl: './customer-system-versions.component.html'
})
export class CustomerSystemVersionsComponent implements OnInit, HasPermissions {
  @ViewChild(GridComponent) grid: GridComponent;
  private customer: Customer;
  public viewEnable = true;

  private headers = [
    { displayName: 'Wersja', propertyName: 'systemVersionName', propertyType: 'string' },
    { displayName: 'Aktualna', propertyName: 'isCurrent', propertyType: 'bool' }
  ];

  constructor(private router: Router, 
              private route: ActivatedRoute, 
              private rest: CustomersRest, 
              private permissionsService: PermissionsService) { }

  @ViewChild(SystemVersionsSelectionComponent) public systemVersionsSelectionModal: SystemVersionsSelectionComponent;

  permissions: Permissions;
  setPermissions(claimType: string): void {
    this.permissions = this.permissionsService.getUserPermissions(claimType);
  }

  ngOnInit() {
  }

  public setModel(customer: Customer) {
    this.customer = customer;
    this.setPermissions('CustomerSystemVersion');
  }

  private getActionButtons() {
    return [];
  }

  private addSystemVersion() {
    this.systemVersionsSelectionModal.openModal(this.customer.id);
  }

  private onRowDelete(row: any) {
    sweetAlert({
      text: "Czy napewno usunąć wersję systemu kontrahenta?",
      buttons: {
        yes: { text: "Tak", value: "yes" },
        no: { text: "Nie", value: "no" }
      }
    }).then((value) => {
      switch (value) {
        case 'yes': {
          if (row.id != null) {
            const action = this.rest.removeCustomerSystemVersions;
            action.call(this.rest, row.id).subscribe((result: String) => {
            });
          }
          sweetAlert({ text: `Usunięto wersję systemu kontrahenta` });
          this.customer.systemVersions.splice(this.customer.systemVersions.indexOf(row), 1);
          this.grid.refreshData();
          break;
        }
      }
    });
  }

  public onSuccessOperation(value) {
    if (value.isSuccess) {
      sweetAlert({ text: `Dodano wersję systemu` });
      const systemVersion = new CustomerSystemVersion();
      systemVersion.isCurrent = true;
      if (value.isSaved) {
        systemVersion.systemVersionName = value.systemVersion.systemVersionName;
        systemVersion.id = value.systemVersion.id
      } else {
        systemVersion.systemVersionName = value.systemVersion.name;
        systemVersion.systemVersionId = value.systemVersion.id
      }
      this.customer.systemVersions.push(systemVersion);
      this.grid.refreshData();
    }
  }
}
